/**
 * GetIdsFromCheckedItems
 *
 * Module that returns an array of checked ids within a given element
 *
 * @return {array}
 */

OT.createNS('OT.Search.Helpers.getIdsFromCheckedItems');

OT.Search.Helpers.getIdsFromCheckedItems = function(el) {

    var ids = [];

    $(el).find('.checkbox').each(function() {
        if(this.checked) {
            ids.push(this.getAttribute('data-id'));
        }
    });

    return ids;

};
